function throttle(f, ms) {
	let timer = 0
	let func = null

	return function () {
		func = () => f.apply(this, arguments)
		if (timer === 0) step()

		function step() {
			if (func === null) {
				timer = 0
				return
			}

			func()
			func = null

			timer = setTimeout(step, ms)
		}
	}
}
